import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Renderiza o alerta "sua loja foi aprovada". O subject e o proprio
 * destinatario (User); os dados de exibicao vem de content() (store_name +
 * username) para montar o link /u/{username}/seller.
 */
export default class SellerApprovedNotification extends Notification {
  icon() {
    return 'fas fa-store';
  }
  href() {
    const username = this.attrs.notification.content()?.username;
    if (!username) return '#';
    return app.route('marketplace.user_seller', {
      username
    });
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.seller_approved', {
      store: data.store_name
    });
  }
  excerpt() {
    return this.attrs.notification.content()?.store_name ?? '';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/SellerApprovedNotification', SellerApprovedNotification);